/* Progressive presentation enhancement: legal provisions are never rewritten. */
(function () {
  'use strict';

  // Capture this before a deferred DOMContentLoaded callback loses currentScript.
  var script = document.currentScript;
  var previewOnly = script && script.getAttribute('data-preview-only') === 'true';
  var previewAllowed = new URLSearchParams(window.location.search)
    .get('tbw_terms_preview') === '20260907';

  if (previewOnly && !previewAllowed) return;
  if (!/\/policies\/terms-of-service\/?$/.test(window.location.pathname)) return;

  function initializeTermsPresentation() {
    var container = document.querySelector('.shopify-policy__container');
    if (!container || container.classList.contains('tbw-terms')) return;

    var policyBody = container.querySelector('.shopify-policy__body');
    var legalText = policyBody && policyBody.querySelector('.rte');
    if (!legalText) return;

    // Presentation labels use the business name for this policy; its URL and provisions stay intact.
    var displayTitle = 'Terms and Conditions';
    var policyTitle = container.querySelector('.shopify-policy__title h1');
    if (policyTitle && /^terms of service$/i.test(policyTitle.textContent.trim())) {
      policyTitle.textContent = displayTitle;
    }
    var firstBlock = legalText.firstElementChild;
    if (firstBlock && firstBlock.tagName === 'P' && firstBlock.children.length === 1 &&
        firstBlock.firstElementChild.tagName === 'STRONG' &&
        /^terms of service$/i.test(firstBlock.textContent.trim())) {
      firstBlock.firstElementChild.textContent = displayTitle;
    }
    Array.prototype.forEach.call(document.querySelectorAll('a[href="/policies/terms-of-service"]'), function (link) {
      if (/^terms of service$/i.test(link.textContent.trim())) link.textContent = displayTitle;
    });

    var headings = Array.prototype.slice.call(legalText.querySelectorAll('h2'));
    // Derive anchors from actual section numbers so later sections need no script edit.
    var usedIds = new Set();
    var sections = headings.map(function (heading) {
      var label = heading.textContent.trim();
      var match = label.match(/^([1-9]\d*)\.\s+\S/);
      if (!match) return null;
      var id = heading.id || 'terms-section-' + match[1];
      var existing = document.getElementById(id);
      if (usedIds.has(id) || (existing && existing !== heading)) return null;
      usedIds.add(id);
      return { heading: heading, label: label, id: id };
    }).filter(function (section) { return section !== null; });
    if (sections.length === 0) return;

    var nav = document.createElement('nav');
    nav.className = 'tbw-terms__nav';
    nav.setAttribute('aria-labelledby', 'tbw-terms-nav-label');
    var label = document.createElement('p');
    label.id = 'tbw-terms-nav-label';
    label.className = 'tbw-terms__nav-label';
    label.textContent = 'Jump to a Section';
    nav.appendChild(label);

    var list = document.createElement('ol');
    list.className = 'tbw-terms__nav-list';
    // Explicit list semantics survive browsers that remove them with list-style:none.
    list.setAttribute('role', 'list');
    sections.forEach(function (section) {
      if (!section.heading.id) section.heading.id = section.id;
      section.heading.setAttribute('tabindex', '-1');
      var item = document.createElement('li');
      item.className = 'tbw-terms__nav-item';
      var link = document.createElement('a');
      link.className = 'tbw-terms__nav-link';
      link.setAttribute('href', '#' + encodeURIComponent(section.id));
      link.textContent = section.label;
      // Own these local jumps to avoid competing native/theme fragment animations.
      // The href remains usable for copying a link or opening it in another tab.
      link.addEventListener('click', function (event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        event.stopPropagation();
        if (window.location.hash !== link.hash) {
          window.history.pushState(window.history.state, '', link.hash);
        }
        goToSection(section);
      });
      item.appendChild(link);
      list.appendChild(item);
    });
    nav.appendChild(list);
    container.insertBefore(nav, policyBody);

    // Existing text, links, address, lists, and heading wording remain untouched.
    // Whitespace-only future paragraphs may lose blank spacing, but not their nodes/text.
    Array.prototype.forEach.call(legalText.querySelectorAll('p'), function (paragraph) {
      if (paragraph.children.length === 0 && paragraph.textContent.trim() === '') {
        paragraph.classList.add('tbw-terms__empty');
      }
    });
    container.classList.add('tbw-terms');

    var header = document.querySelector('.section-header');
    function updateHeaderOffset() {
      var height = header ? Math.ceil(header.getBoundingClientRect().height) : 102;
      container.style.setProperty('--tbw-terms-anchor-offset', Math.max(0, height) + 16 + 'px');
    }
    updateHeaderOffset();
    if (header && typeof ResizeObserver !== 'undefined') {
      var headerObserver = new ResizeObserver(updateHeaderOffset);
      headerObserver.observe(header);
    } else {
      window.addEventListener('resize', updateHeaderOffset, { passive: true });
    }

    function goToSection(section) {
      updateHeaderOffset();
      section.heading.focus({ preventScroll: true });
      section.heading.scrollIntoView({ block: 'start', behavior: 'instant' });
    }

    function followSectionHash() {
      var requestedId;
      try {
        requestedId = decodeURIComponent(window.location.hash.slice(1));
      } catch (error) {
        return;
      }
      var section = sections.find(function (candidate) { return candidate.id === requestedId; });
      if (!section) return;
      goToSection(section);
    }

    // Back/forward can dispatch both events. Run once after native event handlers.
    var pendingHashFrame = null;
    function scheduleSectionHash() {
      if (pendingHashFrame !== null) return;
      pendingHashFrame = window.requestAnimationFrame(function () {
        pendingHashFrame = null;
        followSectionHash();
      });
    }
    window.addEventListener('hashchange', scheduleSectionHash);
    window.addEventListener('popstate', scheduleSectionHash);
    // IDs added after parsing need explicit initial-fragment handling.
    if (window.location.hash) scheduleSectionHash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTermsPresentation, { once: true });
  } else {
    initializeTermsPresentation();
  }
}());
